import React, { Component } from "react";
import { BrowserRouter, Route } from 'react-router-dom';

import { PrivateRoute } from '../components/Authentication';
import NavBar from './NavBar';
import SSO from './SSO';

export default class App extends Component {

    local = false;
    // environment = 'stage';
    environment = 'production';

    render() {
        return (
            <div>
                <BrowserRouter>
                    <div>
                        <Route exact path="/" component={NavBar}></Route>
                        <Route path="/login" render={(props) => <NavBar {...props} local={this.local} environment={this.environment}/>}></Route>
                        <Route path="/sso" render={(props) => <SSO {...props} local={this.local} environment={this.environment}/>}></Route>
                        <PrivateRoute path="/test" component={NavBar} environment={this.environment}></PrivateRoute>
                        <PrivateRoute path="/qa" component={NavBar} environment={this.environment}></PrivateRoute>
                        <PrivateRoute path="/customer" component={NavBar} environment={this.environment}></PrivateRoute>
                        <PrivateRoute path="/assignment" component={NavBar} environment={this.environment}></PrivateRoute>
                        <PrivateRoute path="/quickwin" component={NavBar} environment={this.environment}></PrivateRoute>
                        <PrivateRoute path="/rollbar" component={NavBar} environment={this.environment}></PrivateRoute>
                    </div>
                </BrowserRouter>
            </div>
        )
    }
}



/* 
HEX COLORS:
https://htmlcolorcodes.com/



*/


// WEBPACK FOOTER //
// ./src/js/pages/App.js